import { Progress } from "antd";
import { number, string } from "prop-types";

const percentComplete = (props) => (props.count / props.total) * 100;

const statusColor = (props) => {
  switch (props.status) {
    case "planning":
      return "#faad14";
    case "inProcess":
      return "#108ee9";
    case "complete":
      return "#52c41a";
    case "onHold":
      return "#f5222d";
    default:
      return "#808080";
  }
};

const ProjectInfoCount = (props) => (
  <Progress
    type="circle"
    strokeColor={statusColor(props)}
    percent={percentComplete(props)}
    format={() => `${props.count}/${props.total}`}
  />
);

ProjectInfoCount.propTypes = {
  count: number,
  total: number,
  status: string,
};

export default ProjectInfoCount;
